import React from "react";
import "./Dialog.scss";
import Button from "../../jscomponents/Button/Button";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import LunaLink from "../../jscomponents/LunaLink/LunaLink"

interface DialogProps {
  isOpen: boolean;
  variant: string;
  title: string;
  content: string;
  loadingText?: string;
  primaryButtonText: string;
  secondaryButtonText?: string;
  handleCloseDialog: () => void;
  handleButtonClick?: () => void;
}

const Dialog = ({
  isOpen,
  variant,
  title,
  content,
  loadingText = "Loading...",
  handleCloseDialog,
  primaryButtonText,
  secondaryButtonText = "Cancel",
  handleButtonClick,
  contentWithLink,
  contentLink,
  contentLinkText,
}: DialogProps) => {
  const renderButtons = (variant: string) => {
    if (variant === "primary") {
      return <Button text={primaryButtonText} onClick={handleButtonClick} />;
    } else if (variant === "secondary") {
      return (
        <div className="ter-dialog__buttons">
          <Button text={secondaryButtonText} onClick={handleCloseDialog} />
          <Button
            text={primaryButtonText}
            className="ter-button--primary--2"
            onClick={handleButtonClick}
          />
        </div>
      );
    } else {
      return null;
    }
  };
  return (
    <div className={`${isOpen ? "ter-dialog__overlay" : ""}`}>
      <div
        className={`ter-dialog ${
          isOpen ? "ter-dialog--opened" : "ter-dialog--closed"
        }`}
      >
        {variant === "loading" && (
          <div className="ter-dialog-loading__section">
            <LoadingSpinner />
            {loadingText && (
              <span className="ter-dialog-loading__text">{loadingText}</span>
            )}
          </div>
        )}
        {title && <h1 className="ter-dialog__title">{title}</h1>}
        {content && <div className="ter-dialog__content">{content}</div>}
        {contentWithLink && contentLink && contentLinkText && (
          <p className="ter-dialog__content">
            {contentWithLink} <LunaLink className="ter-dialog__content--link" to={contentLink} >{contentLinkText}</LunaLink>
          </p>
        )}
        {renderButtons(variant)}
      </div>
    </div>
  );
};

export default Dialog;
